import type { SVGProps } from 'react';

const SvgColorPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <path
      fill="#2953A7"
      d="M16.636 19.077c-7.78-4.19-7.626-.032-5.996 1.948 2.09 2.516 5.318 4.617 8.238 5.875 1.062.448 2.024 1.006 3.163 1.269 1.29.295 3.577.886 4.605-.394.82-1.028-.416-2.1-1.006-2.812-.526-.634-1.346-.777-1.97-1.269-1.619-1.302-5.36-3.358-7.034-4.617"
    />
    <path
      fill="#FBC604"
      d="M11.08 16.407c-.518.469-1.276 1.156-1.228 1.597l.05.027c.522-1.032 2.393-1.293 6.734 1.045.774.583 1.991 1.335 3.236 2.106 1.445.894 2.928 1.812 3.798 2.512.257.202.547.346.837.489.413.204.824.407 1.133.78a12 12 0 0 0 .274.313c.517.58 1.177 1.317.964 2.063 2.132-2.558 3.23-6.154-.122-8.766-.93-.733 4.332-6.334 4.693-6.203.468.165.925.544 1.376.917.444.368.88.73 1.315.877.69.23 1.98-1.783 1.587-2.57-.427-.865-10.295-8.425-11.575-7.999-.387.127-.637.674-.849 1.137-.082.18-.158.347-.234.472a1 1 0 0 1-.068.094c-.134.178-.381.507-.239.65.077.077.33.278.64.525.573.458 1.342 1.072 1.548 1.334.132.167-.614.867-1.102 1.325-.121.113-.226.212-.298.284-.766.755-2.079 1.947-3.118 2.844-.28.238-.466.46-.644.672-.232.277-.453.54-.855.806-.434.292-1.277.213-2.06.14-.48-.045-.938-.088-1.266-.042-1.63.23-3.03.94-4.124 2.188-.08.091-.228.224-.403.383"
    />
    <path
      stroke="#292524"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={2.854}
      strokeWidth={0.16}
      d="M16.636 19.077c-7.78-4.19-7.626-.032-5.996 1.948 2.09 2.516 5.318 4.617 8.238 5.875 1.062.448 2.024 1.006 3.163 1.269 1.29.295 3.577.886 4.605-.394.82-1.028-.416-2.1-1.006-2.812-.526-.634-1.346-.777-1.97-1.269-1.619-1.302-5.36-3.358-7.034-4.617z"
    />
    <path
      stroke="#292524"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={2.854}
      strokeWidth={0.16}
      d="M11.08 16.407c-.518.469-1.276 1.156-1.228 1.597l.05.027c.522-1.032 2.393-1.293 6.734 1.045.774.583 1.991 1.335 3.236 2.106 1.445.894 2.928 1.812 3.798 2.512.257.202.547.346.837.489.413.204.824.407 1.133.78a12 12 0 0 0 .274.313c.517.58 1.177 1.317.964 2.063 2.132-2.558 3.23-6.154-.122-8.766-.93-.733 4.332-6.334 4.693-6.203.468.165.925.544 1.376.917.444.368.88.73 1.315.877.69.23 1.98-1.783 1.587-2.57-.427-.865-10.295-8.425-11.575-7.999-.387.127-.637.674-.849 1.137-.082.18-.158.347-.234.472a1 1 0 0 1-.068.094c-.134.178-.381.507-.239.65.077.077.33.278.64.525.573.458 1.342 1.072 1.548 1.334.132.167-.614.867-1.102 1.325-.121.113-.226.212-.298.284-.766.755-2.079 1.947-3.118 2.844-.28.238-.466.46-.644.672-.232.277-.453.54-.855.806-.434.292-1.277.213-2.06.14-.48-.045-.938-.088-1.266-.042-1.63.23-3.03.94-4.124 2.188-.08.091-.228.224-.403.383"
    />
    <path
      fill="#FB8CAC"
      d="M18.6 24.4c0-1.217-1.55-2.3-2.702-1.553-3.051 3.487-5.33 7.035-7.675 11q-.568.96-1.018 1.98c-.752.752-.27 1.406.595.673.864-.733 2.473-2.38 3.25-3.2 2.059-2.192 7.55-8.2 7.55-8.9"
    />
    <path
      fill="#FB8CAC"
      stroke="#292524"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={2.854}
      strokeWidth={0.16}
      d="M18.6 24.4c0-1.217-1.55-2.3-2.702-1.553-3.051 3.487-5.33 7.035-7.675 11q-.568.96-1.018 1.98c-.752.752-.27 1.406.595.673.864-.733 2.473-2.38 3.25-3.2 2.059-2.192 7.55-8.2 7.55-8.9"
    />
  </svg>
);
export default SvgColorPin;
